document.addEventListener("click", function (e) {
  if (e.target.classList.contains("fbs-variant-pill")) {
    
    let pill = e.target;
    let parent = pill.closest(".fbs-card");

    // Remove active class
    pill.parentElement.querySelectorAll(".fbs-variant-pill").forEach(p => p.classList.remove("active"));
    pill.classList.add("active");

    let price = pill.dataset.price;
    let compare = pill.dataset.compare;

    parent.querySelector(".fbs-price").innerText = "₹" + (price / 100);

    let compareEl = parent.querySelector(".fbs-compare");
    let discountEl = parent.querySelector(".fbs-discount");

    if (compare > price) {
      if (!compareEl) {
        // Insert compare & discount if missing
        parent.querySelector(".fbs-price-box").innerHTML += `
          <span class="fbs-compare"></span>
          <span class="fbs-discount"></span>
        `;
        compareEl = parent.querySelector(".fbs-compare");
        discountEl = parent.querySelector(".fbs-discount");
      }
      
      compareEl.innerText = "₹" + (compare / 100);
      let off = Math.round((compare - price) * 100 / compare);
      discountEl.innerText = off + "% OFF";

    } else {
      if (compareEl) compareEl.remove();
      if (discountEl) discountEl.remove();
    }

    // update add to cart button variant id
    parent.querySelector(".fbs-add-btn").dataset.variantId = pill.dataset.variantId;
  }
});
